import axios from 'axios';
import { Base64 } from 'js-base64';

function getCookie(cookie) {
    var cookie_data = document.cookie.match('(^|;)\\s*' + cookie + '\\s*=\\s*([^;]+)');
    return cookie_data ? cookie_data.pop() : null;
}
function getSVOCID() {
    let svoc = getCookie('THD_USER')
    return checkForValue(svoc);
}
function checkForValue(value) {
    if (value === undefined || value === null) {
        window.location.replace(window.location.origin + "auth/view/signin?redirect=/account/view/instantcheckout");
    }
    else {
        value = Base64.decode(value)
        value = JSON.parse(value)
        value = value.svocCustomerAccountId;
        return value;
    }
}
function getChannelID() {
    const THD_ACCOUNT_GLOBAL = THD_ACCOUNT_GLOBAL;
    if(THD_ACCOUNT_GLOBAL){
        switch(THD_ACCOUNT_GLOBAL.channel){
            case 'desktop':
                return 1;
                break;
            case 'mobile':
                return 2;
                break;
            default:
                return 1;
                break;
        }
    }
    else{
        return 1;
    }
}
function getProfile() {
    const url = '/customer/account/v1/' + getSVOCID() + '/profile';
    var tmxprofileId = '';
    if (window.THD_ACCOUNT_LIB &&
        window.THD_ACCOUNT_LIB.TMX &&
        window.THD_ACCOUNT_LIB.TMX.getTMXsessionId()) {
            tmxprofileId = window.THD_ACCOUNT_LIB.TMX.getTMXsessionId();
    }
    return axios({
        method: 'get',
        url: url,
        headers: {
          'Content-Type': 'application/json',
          'channelid': getChannelID(),
          'Authorization': getCookie('THD_USER_SESSION') || getCookie('THD_CUSTOMER') || ' ',
          'TMXProfileID': tmxprofileId
        }
    })
        .then(function (response) {
            return response.data.account;
        })
        .catch(function (error) {
            console.log(error);
        });
}

export { getProfile }



// WEBPACK FOOTER //
// ./src/api/ProfileAPI.js